<style lang="scss" scoped>
.tags {
    display: flex;
    flex-wrap: wrap;
    margin: -4px;
    .tag {
        padding: 5px 10px;
        border-radius: 2px;
        background-color: var(--border-color);
        font-size: 80%;
        margin: 4px;
        text-align: center;
        cursor: pointer;
        transition: background 0.2s;
        user-select: none;
        display: flex;
        &:hover {
            .close {
                display: flex;
            }
        }
        .close {
            margin: auto 0 auto 10px;
            width: 18px;
            height: 18px;
            display: none;
            position: relative;
            &:before,
            &:after {
                content: "";
                height: 1px;
                width: 10px;
                background: var(--gray);
                display: block;
                margin: auto;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            &:before {
                transform: rotate(45deg);
            }
            &:after {
                transform: rotate(-45deg);
            }
        }
        &.active {
            background-color: var(--primary-dark);
            color: #fff;
        }
        &.add-tag {
            background-color: transparent;
        }
        &.create-tag {
            input {
                outline: none;
                box-shadow: none;
                border: none;
                background: transparent;
                padding: 0;
            }
        }
    }
}
</style>

<template>
    <div>

        <router-link class="small text-dark mb-32 d-flex" :to="{ name: 'onboarding-sleepprofile' }">
            <i-back class="i-14 mr-16 fill-gold my-auto"></i-back>
            {{ $t('general.back')}}
        </router-link>

        <h1 class="mb-32">{{ $t('pages.onboarding-personal.title') }}</h1>
        <el-form @submit="submit" class="pb-32">

            <template slot="default">

                <div class="row">
                    <div class="col-12 col-lg-7 offset-lg-3">
                        <el-error class="mb-16" :error="server_error"></el-error>
                    </div>
                </div>

                <div class="form-row">

                    <div class="col-12">
                        <p class="fw-b mb-16">{{ $t('pages.onboarding-personal.global_medical_info') }}</p>
                    </div>

                    <div class="col-12 col-lg-3 d-flex">
                        <p class="my-auto small">{{ $t('form-elements.doctor') }}</p>
                    </div>
                    <div class="col-12 col-lg-7">
                        <el-input v-model="data.physician" type="text" rule="required" :name="$t('form-elements.doctor')" :hasLabel="false" :placeholder="$t('form-elements.doctor_placeholder')">

                        </el-input>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 col-lg-3 d-flex">
                        <p class="my-auto small">{{ $t('form-elements.insurance') }}</p>
                    </div>
                    <div class="col-12 col-lg-7">
                        <el-input v-model="data.health_insurance" type="text" rule="required" :name="$t('form-elements.insurance')" :hasLabel="false" :placeholder="$t('form-elements.insurance_placeholder')">

                        </el-input>
                    </div>
                </div>

                <div class="form-row mb-32">
                    <div class="col-12 col-lg-7 offset-lg-3  mb-8">
                        <span v-if="errors.has('birthdate')" class="label-error small fw-b">
                            {{ errors.first('birthdate') }}
                        </span>
                    </div>
                    <div class="col-12 col-lg-3 d-flex">
                        <p class="my-auto small">{{ $t('form-elements.birthdate') }}</p>
                    </div>
                    <div class="col-12 col-lg-7">
                        <div class="row">
                            <datepicker v-validate="'required'" :data-vv-as="$t('form-elements.birthdate')" class="col-12 mb-16" initial-view="year" v-model="data.birth_date" :bootstrap-styling="true" name="birthdate" :label="$t('form-elements.birthdate')" :placeholder="$t('form-elements.birthdate_placeholder')"></datepicker>
                        </div>
                    </div>
                </div>

                <div class="form-row">

                    <div class="col-12">
                        <p class="fw-b mb-16">{{ $t('pages.onboarding-personal.psychological_complaints') }}</p>
                    </div>
                    <div class="col-12 col-lg-3 d-flex mb-16">
                        <p class="my-auto small">{{ $t('form-elements.psychologist') }}</p>
                    </div>
                    <div class="col-12 col-lg-7 mb-32">
                        <p-input type="radio" name="checkbox" class="p-default text-wrap p-round p-smooth mr-16" color="success-o" :checked="has_psychologist" :value="has_psychologist" @change="() => { has_psychologist = true }">{{ $t('general.yes') }}</p-input>
                        <p-input type="radio" name="checkbox" class="p-default text-wrap p-round p-smooth" color="success-o" :checked="!has_psychologist" :value="!has_psychologist" @change="() => { has_psychologist = false }">{{ $t('general.no') }}</p-input>
                    </div>
                    <div v-if="has_psychologist" class="col-12 col-lg-7 offset-lg-3 mb-16">
                        <el-input v-model="data.psychologist" class="no-top-margin" type="text" rule="required" :name="$t('form-elements.name_psychologist')" :label="$t('form-elements.name_psychologist')" :placeholder="$t('form-elements.name_psychologist_placeholder')" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 col-lg-7 offset-lg-3  mb-8">
                        <span v-if="has_psychologist" class="label-error small fw-b">
                            {{ $t('form-elements.psychological_complaints_error') }}
                        </span>
                    </div>
                    <div class="col-12 col-lg-3 d-flex mb-32">
                        <p class="my-auto small pr-lg-16">{{ $t('form-elements.psychological_complaints') }}</p>
                    </div>
                    <el-psychological-compaints class="col-12 col-lg-7 mb-32" :show_error="has_psychologist && data.psychological_complaint_ids.length === 0 && validated" v-model="data.psychological_complaint_ids" :user_id="currentUser.user.id"></el-psychological-compaints>

                    <div class="col-12 col-lg-7 offset-lg-3">
                        <el-input v-model="data.psychological_complaint_reason" class="no-top-margin" type="textarea" :rows="3" :rule="psychologicalComplaintReasonRules" :name="$t('form-elements.specify')" :label="$t('form-elements.specify')" :placeholder="$t('form-elements.specify_placeholder')">
                            <template v-if="data.psychological_complaint_reason" slot="label-cta">
                                <span class="ml-auto"> {{ data.psychological_complaint_reason.length }} / 100</span>
                            </template>
                        </el-input>
                    </div>
                </div>

            </template>

            <template slot="footer">
                <button id="personal_onboarding_submit" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex ml-auto" v-bind:class="{ disabled : loading }">
                    {{ $t('general.next') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>
    </div>
</template>

<script>
import { ElInput, ElForm, PInput, ElError, ElPsychologicalCompaints } from '@/components/forms'
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'page-onboarding-profession',

    components: { ElInput, ElForm, PInput, ElError, ElPsychologicalCompaints, Datepicker },

    data: () => ({
        loading: false,
        success: false,
        server_error: null,

        has_psychologist: false,

        data: {
            physician: null,
            health_insurance: null,
            psychologist: null,
            psychological_complaint_ids: [],
            psychological_complaint_reason: null,
            birth_date: null,
        },
        validated: false
    }),

    mounted() {
        if (this.currentUser.user && this.currentUser.user.personal_info_id)
            this.$store.dispatch('user/readPersonalInfo', { user_id: this.currentUser.user.id, id: this.currentUser.user.personal_info_id }).then((personalInfo) => {
                this.data.id = personalInfo.id
                this.data.physician = personalInfo.physician
                this.data.health_insurance = personalInfo.health_insurance
                this.data.psychologist = personalInfo.psychologist
                this.data.birth_date = personalInfo.birth_date
                if (this.data.psychologist !== null) this.has_psychologist = true
                this.data.psychological_complaint_ids = personalInfo.psychological_complaint_ids
                this.data.psychological_complaint_reason = personalInfo.psychological_complaint_reason
                this.update = true
                this.$nextTick().then(() => this.$validator.validateAll())
            })
    },

    methods: {
        submit() {
            this.validated = true
            this.$validator.validateAll().then(res => {
                if (res && ((this.has_psychologist && this.data.psychological_complaint_ids.length !== 0) || !this.has_psychologist)) {
                    this.loading = true
                    let user_id = this.currentUser.user.id

                    if (this.data.birth_date) {
                        this.data.birth_date = this.$moment(this.data.birth_date).format('YYYY-MM-DD')
                    }

                    this.$store.dispatch(`user/${!this.update ? 'createPersonalInfo' : 'updatePersonalInfo'}`, { user_id, data: this.data }).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.$router.push({ name: 'onboarding-medical' })
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        isFormValid() {
            return !Object.keys(this.fields).some(key => this.fields[key].invalid)
        },
        psychologicalComplaintReasonRules() {
            return {
                max: 100,
                required: this.has_psychologist || this.data.psychological_complaint_ids.length > 0
            }
        }
    }
}
</script>
